module.exports = __webpack_public_path__ + "img/276FnaspW-gic1_UQ8xkXT.f74e8508.svg";